import React, { useState } from "react";
import { AES, enc } from "crypto-js";
import swal from "sweetalert";
import { ArrowCircleDown } from "phosphor-react";
import { BASE_URL } from "../CommonApi";
import "./CustomerNew.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Alert from "@mui/material/Alert";
import Select from "../../../Components/forms/SearchableDropdown";
import { Card, Form, Container, Row, Col } from "react-bootstrap";

function CustomerNew({ navigation }) {
  const [billCountry, setBillingCountry] = useState("India");
  const [billState, setBillingState] = useState("Maharashtra");
  const [shipAttention, setShippingAttention] = useState("");
  const [shipCountry, setShippingCountry] = useState("India");
  const [shipAddress1, setShippingAddress1] = useState("");
  const [shipAddress2, setShippingAddress2] = useState("");
  const [shipCity, setShippingCity] = useState("");
  const [shipState, setShippingState] = useState("Maharashtra");
  const [shipZipcode, setShippingZipcode] = useState("");
  const [shipPhone, setShippingPhone] = useState("");
  const [shipFax, setShippingFax] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const jwtToken = localStorage.getItem("jwtToken");
  const handleInputChange = (event) => {
    setGstNumber(event.target.value);
  };
  const handleNavigation = (key) => {
    if (navigation.state.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };
  const handleProfileClick = () => {
    const confirmCancel = window.confirm("Are you sure Leave this page?");
    if (confirmCancel) {
      // Code to handle cancellation
      handleNavigation("Customers");
    } else {
      // Code to handle cancellation not confirmed
      console.log("Cancellation not confirmed");
    }
  };

  const copyData = () => {
    setShippingAttention(formData.billAttention);
    setShippingCountry(billCountry);
    setShippingAddress1(formData.billAddress1);
    setShippingAddress2(formData.billAddress2);
    setShippingCity(formData.billCity);
    setShippingState(billState);
    setShippingZipcode(formData.billZipcode);
    setShippingPhone(formData.billPhone);
    setShippingFax(formData.billFax);
    setFormData((prevFormData) => ({
      ...prevFormData,
      shipAttention: formData.billAttention,
      shipCountry: billCountry,
      shipAddress1: formData.billAddress1,
      shipAddress2: formData.billAddress2,
      shipCity: formData.billCity,
      shipState: billState,
      shipZipcode: formData.billZipcode,
      shipPhone: formData.billPhone,
      shipFax: formData.billFax,
    }));
  };

  const handleAdd = () => {
    const newContactPerson = {
      other: "",
      otherFirstname: "",
      otherLastname: "",
      otherEmail: "",
      otherWorkphone: "",
      otherMobile: "",
    };

    setFormData((prevData) => ({
      ...prevData,
      contactPerson: [...prevData.contactPerson, newContactPerson],
    }));
  };

  const handleDelete = (i) => {
    const updatedContactPerson = [...formData.contactPerson];
    updatedContactPerson.splice(i, 1);

    // Update the formData state with the updated contactPerson array
    setFormData((prevData) => ({
      ...prevData,
      contactPerson: updatedContactPerson,
    }));
  };

  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);

  const handleCancleClick = () => {
    handleProfileClick();
  };

  const [selectedOption, setSelectedOption] = useState("");
  const [new1, showNew1] = useState(true);
  const [new2, showNew2] = useState(false);
  const [new3, showNew3] = useState(false);

  const [selectedOther, setSelectedOther] = useState("");

  const [formData, setFormData] = useState({
    uniqueId: decryptedUniqueId,
    customerType: "Business",
    status: "Active",
    someName: "",
    firstName: "",
    lastName: "",
    companyName: "",
    customerName: "",
    email: "",
    workphone: "",
    mobile: "",
    designation: "",
    department: "",
    website: "",
    currency: "INR- Indian Rupee",
    openingBalance: "0",
    paymentTerms: "Net 15",
    facebook: "",
    twitter: "",
    billAttention: "",
    billCountry: "India",
    billAddress1: "",
    billAddress2: "",
    billCity: "",
    billState: "Maharashtra",
    billZipcode: "",
    billPhone: "",
    billFax: "",
    shipAttention: "",
    shipCountry: "India",
    shipAddress1: "",
    shipAddress2: "",
    shipCity: "",
    shipState: "Maharashtra",
    shipZipcode: "",
    shipPhone: "",
    shipFax: "",
    gstin: "",
    pan: "",
    placeOfSupply: "[MH] - Maharashtra",
    taxable: "",
    reason: "",
    activeStatus: "Active",
    gstTreatment: "",
    contactPerson: [
      {
        other: selectedOther,
        otherFirstname: "",
        otherLastname: "",
        otherEmail: "",
        otherWorkphone: "",
        otherMobile: "",
      },
    ],
  });

  const handleOtherSalutation = (selectedOption) => {
    setSelectedOther(selectedOption.value);
  };

  const unitSalution = [
    { value: "Mr.", label: "Mr." },
    { value: "Mrs.", label: "Mrs." },
    { value: "Ms.", label: "Ms." },
    { value: "Miss.", label: "Miss." },
    { value: "Dr.", label: "Dr." },
  ];

  const [validationMessage, setValidationMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveClick = () => {
    let newValidationMessage = "";

    if (!formData.customerName) {
      newValidationMessage += "Please enter a customer display name.\n";
    }
    if (formData.email && !/^[a-z0-9._%+-]+@[a-z]+\.[a-z]{2,4}(\.[a-z]{2,4})?$/.test(formData.email)) {
      newValidationMessage += "Invalid Email Address. Please enter a valid email.\n";
    }
    if (formData.mobile && !/^\d{10}$/.test(formData.mobile)) {
      newValidationMessage += "Invalid Mobile Number. Please enter a 10-digit number.\n";
    }
    if (formData.workphone && !/^\d{10}$/.test(formData.workphone)) {
      newValidationMessage += "Invalid Phone Number. Please enter a 10-digit number.\n";
    }
    if (formData.billPhone && !/^\d{10}$/.test(formData.billPhone)) {
      newValidationMessage += "Invalid Billing Phone Number. Please enter a 10-digit number.\n";
    }
    if (formData.billZipcode && !/^\d{5,6}$/.test(formData.billZipcode)) {
      newValidationMessage += "Invalid Zipcode. Please enter a valid 5 or 6-digit zipcode.\n";
    }
    // if (formData.shipPhone && !/^\d{10}$/.test(formData.shipPhone)) {
    //   newValidationMessage += "Invalid Shipping Phone Number. Please enter a 10-digit number.\n";
    // }

    formData.contactPerson.forEach((person, index) => {
      if (person.otherMobile && !/^\d{10}$/.test(person.otherMobile)) {
        newValidationMessage += `Invalid Contact Person Mobile Number for contact ${index + 1}. Please enter a 10-digit number.\n`;
      }
      if (person.otherWorkphone && !/^\d{10}$/.test(person.otherWorkphone)) {
        newValidationMessage += `Invalid Contact Person Work Phone Number for contact ${index + 1}. Please enter a 10-digit number.\n`;
      }
      if (person.otherEmail && !/^[a-z0-9._%+-]+@[a-z]+\.[a-z]{2,4}(\.[a-z]{2,4})?$/.test(person.otherEmail)) {
        newValidationMessage += "Invalid Contact Person Email Address. Please enter a valid email.\n";
      }
    });

    setValidationMessage(newValidationMessage);

    if (newValidationMessage) {
      window.scrollTo(0, 0);
      // alert(newValidationMessage.trim()); // Trim trailing newline for better formatting
      return; // Exit function if validation fails
    }
    setIsLoading(true);

    fetch(BASE_URL + "/createCustomer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          swal({
            icon: "success",
            title: "Customer Created",
            text: "",
          });
          handleNavigation("Customers");
          setIsLoading(false);
        } else if (data.responseCode === "400") {
          swal({
            icon: "error",
            title: "This email already exists, please insert another email.",
            text: "",
          });
          setIsLoading(false);
        } else {
          swal({
            icon: "error",
            title: "Failed to Create Customer!",
            text: "",
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: "Network Error",
          text: "An error occurred while communicating with the server.",
        });
      });
  };

  const handleOtherChange = (event, index) => {
    const { name, value } = event.target;
    const updatedFormData = { ...formData };
    if (
      !updatedFormData.contactPerson ||
      index >= updatedFormData.contactPerson.length
    ) {
      console.error("Invalid index or formData structure");
      return;
    }
    updatedFormData.contactPerson[index][name] = value;
    setFormData(updatedFormData);
  };

  const handleContactSalutation = (option, index) => {
    setFormData((current) => ({
      ...current,
      contactPerson: current.contactPerson.map((person, personIndex) =>
        personIndex === index ? { ...person, other: option?.value || "" } : person
      ),
    }));
  };

  const generateNamePairs = () => {
    const { someName, firstName, lastName, companyName } = formData;
    const pairs = [];

    if (firstName && lastName) {
      pairs.push(`${someName} ${firstName} ${lastName}`);
      pairs.push(`${firstName} ${lastName}`);
      pairs.push(`${lastName} , ${firstName}`);
      pairs.push(`${companyName}`);
    }

    return pairs;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [showTaxable, setShowTaxable] = useState(true);

  const handleTaxable = (e, value) => {
    setFormData({
      ...formData,
      taxable: value,
    });
    if (value === "Taxable") {
      setShowTaxable(true);
    }
    if (value === "Non-Taxable") {
      setShowTaxable(false);
    }
  };

  const handleGSTtreatment = (selectedOption) => {
    setSelectedOption(selectedOption.value); // Update selected option
    setFormData({
      ...formData,
      gstTreatment: selectedOption.value, // Update gstTreatment in formData
    });
  };

  const handlePlaceOfSupply = (selectedOption) => {
    setSelectedOption(selectedOption.value); // Update selected option
    setFormData({
      ...formData,
      placeOfSupply: selectedOption.value, // Update gstTreatment in formData
    });
  };

  const handleCurrency = (selectedOption) => {
    setSelectedOption(selectedOption); // Update selected option
    setFormData({
      ...formData,
      currency: selectedOption.value, // Update gstTreatment in formData
    });
  };

  const handlePaymentTerms = (selectedOption) => {
    setSelectedOption(selectedOption); // Update selected option
    setFormData({
      ...formData,
      paymentTerms: selectedOption.value, // Update gstTreatment in formData
    });
  };

  const handlePanChange = (event) => {
    setFormData({
      ...formData,
      pan: event.target.value,
    });
  };

  const handleGstChange = (event) => {
    setFormData({
      ...formData,
      gstin: event.target.value,
    });
  };

  const GstTreatment = [
    { value: "", label: "Select a GST Treatment", isDisabled: true },
    {
      value: "Registered Business - Regular",
      label: "Registered Business - Regular",
    },
    {
      value: "Registered Business - Composition",
      label: "Registered Business - Composition",
    },
    { value: "Unregistered Business", label: "Unregistered Business" },
    { value: "Consumer", label: "Consumer" },
    { value: "Overseas", label: "Overseas" },
    { value: "Special Economic Zone", label: "Special Economic Zone" },
    { value: "Deemed Export", label: "Deemed Export" },
    { value: "Tax Deductor", label: "Tax Deductor" },
    { value: "SEZ Developer", label: "SEZ Developer" },
  ];

  const PlaceOfSupplyOptions = [
    { value: "", label: "Source Of Supply", isDisabled: true },
    {
      value: "[AN] - Andaman and Nicobar Islands",
      label: "[AN] - Andaman and Nicobar Islands",
    },
    { value: "[AD] - Andhra Pradesh", label: "[AD] - Andhra Pradesh" },
    { value: "[AR] - Arunachal Pradesh", label: "[AR] - Arunachal Pradesh" },
    { value: "[AS] - Assam", label: "[AS] - Assam" },
    { value: "[BR] - Bihar", label: "[BR] - Bihar" },
    { value: "[CH] - Chandigarh", label: "[CH] - Chandigarh" },
    { value: "[CG] - Chhattisgarh", label: "[CG] - Chhattisgarh" },
    {
      value: "[DN] - Dadra and Nagar Haveli and Daman and Diu",
      label: "[DN] - Dadra and Nagar Haveli and Daman and Diu",
    },
    { value: "[DD] - Daman and Diu", label: "[DD] - Daman and Diu" },
    { value: "[DL] - Delhi", label: "[DL] - Delhi" },
    { value: "[GA] - Goa", label: "[GA] - Goa" },
    { value: "[GJ] - Gujarat", label: "[GJ] - Gujarat" },
    { value: "[HR] - Haryana", label: "[HR] - Haryana" },
    { value: "[HP] - Himachal Pradesh", label: "[HP] - Himachal Pradesh" },
    { value: "[JK] - Jammu and Kashmir", label: "[JK] - Jammu and Kashmir" },
    { value: "[JH] - Jharkhand", label: "[JH] - Jharkhand" },
    { value: "[KA] - Karnataka", label: "[KA] - Karnataka" },
    { value: "[KL] - Kerala", label: "[KL] - Kerala" },
    { value: "[LA] - Ladakh", label: "[LA] - Ladakh" },
    { value: "[LD] - Lakshadweep", label: "[LD] - Lakshadweep" },
    { value: "[MP] - Madhya Pradesh", label: "[MP] - Madhya Pradesh" },
    { value: "[MH] - Maharashtra", label: "[MH] - Maharashtra" },
    { value: "[MN] - Manipur", label: "[MN] - Manipur" },
    { value: "[ML] - Meghalaya", label: "[ML] - Meghalaya" },
    { value: "[MZ] - Mizoram", label: "[MZ] - Mizoram" },
    { value: "[NL] - Nagaland", label: "[NL] - Nagaland" },
    { value: "[OD] - Odisha", label: "[OD] - Odisha" },
    { value: "[OT] - Other Territory", label: "[OT] - Other Territory" },
    { value: "[PY] - Puducherry", label: "[PY] - Puducherry" },
    { value: "[PB] - Punjab", label: "[PB] - Punjab" },
    { value: "[RJ] - Rajasthan", label: "[RJ] - Rajasthan" },
    { value: "[SK] - Sikkim", label: "[SK] - Sikkim" },
    { value: "[TN] - Tamil Nadu", label: "[TN] - Tamil Nadu" },
    { value: "[TS] - Telangana", label: "[TS] - Telangana" },
    { value: "[TR] - Tripura", label: "[TR] - Tripura" },
    { value: "[UP] - Uttar Pradesh", label: "[UP] - Uttar Pradesh" },
    { value: "[UK] - Uttarakhand", label: "[UK] - Uttarakhand" },
    { value: "[WB] - West Bengal", label: "[WB] - West Bengal" },
  ];

  const CurrencyOptions = [
    { value: "", label: "Select Currency ...", isDisabled: true },
    { value: "AED- UAE Dirham", label: "AED- UAE Dirham" },
    { value: "AUD- Australian Dollar", label: "AUD- Australian Dollar" },
    { value: "CAD- Canadian Dollar", label: "CAD- Canadian Dollar" },
    { value: "CNY- Yuan Renminbi", label: "CNY- Yuan Renminbi" },
    { value: "EUR- Euro", label: "EUR- Euro" },
    { value: "GBP- Pound Sterling", label: "GBP- Pound Sterling" },
    { value: "INR- Indian Rupee", label: "INR- Indian Rupee" },
    { value: "JPY- Japanese Yen", label: "JPY- Japanese Yen" },
    { value: "SAR- Saudi Riyal", label: "SAR- Saudi Riyal" },
    { value: "USD- United States Dollar", label: "USD- United States Dollar" },
    { value: "ZAR- South African Rand", label: "ZAR- South African Rand" },
  ];

  const PaymentTermsOptions = [
    { value: "", label: "Select Payment Terms", isDisabled: true },
    { value: "Net 15", label: "Net 15" },
    { value: "Net 30", label: "Net 30" },
    { value: "Net 45", label: "Net 45" },
    { value: "Net 60", label: "Net 60" },
    { value: "Due end of the month", label: "Due end of the month" },
    { value: "Due end of next month", label: "Due end of next month" },
    { value: "Due on Receipt", label: "Due on Receipt" },
  ];

  const countryOptions = [
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Algeria", label: "Algeria" },
    { value: "American Samoa", label: "American Samoa" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Anguilla", label: "Anguilla" },
    { value: "Antarctica", label: "Antarctica" },
    { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
    { value: "Argentina", label: "Argentina" },
    { value: "Armenia", label: "Armenia" },
    { value: "Aruba", label: "Aruba" },
    { value: "Australia", label: "Australia" },
    { value: "Austria", label: "Austria" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgium", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bermuda", label: "Bermuda" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Bouvet Island", label: "Bouvet Island" },
    { value: "Brazil", label: "Brazil" },
    {
      value: "British Indian Ocean Territory",
      label: "British Indian Ocean Territory",
    },
    { value: "Brunei Darussalam", label: "Brunei Darussalam" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Burkina Faso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Canada", label: "Canada" },
    { value: "Cape Verde", label: "Cape Verde" },
    { value: "Cayman Islands", label: "Cayman Islands" },
    { value: "Central African Republic", label: "Central African Republic" },
    { value: "Chad", label: "Chad" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "Christmas Island", label: "Christmas Island" },
    { value: "Cocos (Keeling) Islands", label: "Cocos (Keeling) Islands" },
    { value: "Colombia", label: "Colombia" },
    { value: "Comoros", label: "Comoros" },
    { value: "Congo", label: "Congo" },
    {
      value: "Congo, the Democratic Republic of the",
      label: "Congo, the Democratic Republic of the",
    },
    { value: "Cook Islands", label: "Cook Islands" },
    { value: "Costa Rica", label: "Costa Rica" },
    { value: "Côte d'Ivoire", label: "Côte d'Ivoire" },
    { value: "Croatia", label: "Croatia" },
    { value: "Cuba", label: "Cuba" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Denmark", label: "Denmark" },
    { value: "Djibouti", label: "Djibouti" },
    { value: "Dominica", label: "Dominica" },
    { value: "Dominican Republic", label: "Dominican Republic" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Egypt", label: "Egypt" },
    { value: "El Salvador", label: "El Salvador" },
    { value: "Equatorial Guinea", label: "Equatorial Guinea" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estonia", label: "Estonia" },
    { value: "Ethiopia", label: "Ethiopia" },
    {
      value: "Falkland Islands (Malvinas)",
      label: "Falkland Islands (Malvinas)",
    },
    { value: "Faroe Islands", label: "Faroe Islands" },
    { value: "Fiji", label: "Fiji" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "French Guiana", label: "French Guiana" },
    { value: "French Polynesia", label: "French Polynesia" },
    {
      value: "French Southern Territories",
      label: "French Southern Territories",
    },
    { value: "Gabon", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgia", label: "Georgia" },
    { value: "Germany", label: "Germany" },
    { value: "Ghana", label: "Ghana" },
    { value: "Gibraltar", label: "Gibraltar" },
    { value: "Greece", label: "Greece" },
    { value: "Greenland", label: "Greenland" },
    { value: "Grenada", label: "Grenada" },
    { value: "Guadeloupe", label: "Guadeloupe" },
    { value: "Guam", label: "Guam" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guernsey", label: "Guernsey" },
    { value: "Guinea", label: "Guinea" },
    { value: "Guinea-Bissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    {
      value: "Heard Island and McDonald Islands",
      label: "Heard Island and McDonald Islands",
    },
    {
      value: "Holy See (Vatican City State)",
      label: "Holy See (Vatican City State)",
    },
    { value: "Honduras", label: "Honduras" },
    { value: "Hong Kong", label: "Hong Kong" },
    { value: "Hungary", label: "Hungary" },
    { value: "Iceland", label: "Iceland" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Iran, Islamic Republic of", label: "Iran, Islamic Republic of" },
    { value: "Iraq", label: "Iraq" },
    { value: "Ireland", label: "Ireland" },
    { value: "Isle of Man", label: "Isle of Man" },
    { value: "Israel", label: "Israel" },
    { value: "Italy", label: "Italy" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jersey", label: "Jersey" },
    { value: "Jordan", label: "Jordan" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Kenya", label: "Kenya" },
    { value: "Kiribati", label: "Kiribati" },
    {
      value: "Korea, Democratic People's Republic of",
      label: "Korea, Democratic People's Republic of",
    },
    { value: "Korea, Republic of", label: "Korea, Republic of" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    {
      value: "Lao People's Democratic Republic",
      label: "Lao People's Democratic Republic",
    },
    { value: "Latvia", label: "Latvia" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libyan Arab Jamahiriya", label: "Libyan Arab Jamahiriya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Macao", label: "Macao" },
    {
      value: "Macedonia, the former Yugoslav Republic of",
      label: "Macedonia, the former Yugoslav Republic of",
    },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Maldives", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marshall Islands", label: "Marshall Islands" },
    { value: "Martinique", label: "Martinique" },
    { value: "Mauritania", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mayotte", label: "Mayotte" },
    { value: "Mexico", label: "Mexico" },
    {
      value: "Micronesia, Federated States of",
      label: "Micronesia, Federated States of",
    },
    { value: "Moldova, Republic of", label: "Moldova, Republic of" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Montserrat", label: "Montserrat" },
    { value: "Morocco", label: "Morocco" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "Netherlands Antilles", label: "Netherlands Antilles" },
    { value: "New Caledonia", label: "New Caledonia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "Niue", label: "Niue" },
    { value: "Norfolk Island", label: "Norfolk Island" },
    { value: "Northern Mariana Islands", label: "Northern Mariana Islands" },
    { value: "Norway", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palau", label: "Palau" },
    {
      value: "Palestinian Territory, Occupied",
      label: "Palestinian Territory, Occupied",
    },
    { value: "Panama", label: "Panama" },
    { value: "Papua New Guinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippines", label: "Philippines" },
    { value: "Pitcairn", label: "Pitcairn" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Puerto Rico", label: "Puerto Rico" },
    { value: "Qatar", label: "Qatar" },
    { value: "Réunion", label: "Réunion" },
    { value: "Romania", label: "Romania" },
    { value: "Russian Federation", label: "Russian Federation" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "Saint Barthélemy", label: "Saint Barthélemy" },
    {
      value: "Saint Helena, Ascension and Tristan da Cunha",
      label: "Saint Helena, Ascension and Tristan da Cunha",
    },
    { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
    { value: "Saint Lucia", label: "Saint Lucia" },
    {
      value: "Saint Martin (French part)",
      label: "Saint Martin (French part)",
    },
    { value: "Saint Pierre and Miquelon", label: "Saint Pierre and Miquelon" },
    {
      value: "Saint Vincent and the Grenadines",
      label: "Saint Vincent and the Grenadines",
    },
    { value: "Samoa", label: "Samoa" },
    { value: "San Marino", label: "San Marino" },
    { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbia", label: "Serbia" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Sierra Leone", label: "Sierra Leone" },
    { value: "Singapore", label: "Singapore" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Solomon Islands", label: "Solomon Islands" },
    { value: "Somalia", label: "Somalia" },
    { value: "South Africa", label: "South Africa" },
    {
      value: "South Georgia and the South Sandwich Islands",
      label: "South Georgia and the South Sandwich Islands",
    },
    { value: "Spain", label: "Spain" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suriname", label: "Suriname" },
    { value: "Svalbard and Jan Mayen", label: "Svalbard and Jan Mayen" },
    { value: "Swaziland", label: "Swaziland" },
    { value: "Sweden", label: "Sweden" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Syrian Arab Republic", label: "Syrian Arab Republic" },
    { value: "Taiwan, Province of China", label: "Taiwan, Province of China" },
    { value: "Tajikistan", label: "Tajikistan" },
    {
      value: "Tanzania, United Republic of",
      label: "Tanzania, United Republic of",
    },
    { value: "Thailand", label: "Thailand" },
    { value: "Timor-Leste", label: "Timor-Leste" },
    { value: "Togo", label: "Togo" },
    { value: "Tokelau", label: "Tokelau" },
    { value: "Tonga", label: "Tonga" },
    { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Turkey", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Turks and Caicos Islands", label: "Turks and Caicos Islands" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "United Arab Emirates", label: "United Arab Emirates" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "United States", label: "United States" },
    {
      value: "United States Minor Outlying Islands",
      label: "United States Minor Outlying Islands",
    },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    {
      value: "Venezuela, Bolivarian Republic of",
      label: "Venezuela, Bolivarian Republic of",
    },
    { value: "Viet Nam", label: "Viet Nam" },
    { value: "Virgin Islands, British", label: "Virgin Islands, British" },
    { value: "Virgin Islands, U.S.", label: "Virgin Islands, U.S." },
    { value: "Wallis and Futuna", label: "Wallis and Futuna" },
    { value: "Western Sahara", label: "Western Sahara" },
    { value: "Yemen", label: "Yemen" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
  ];

  const handleCountryChange = (selectedOption) => {
    setBillingCountry(selectedOption.value);
  };

  const indianStateOptions = [
    { value: "AP", label: "Andhra Pradesh" },
    { value: "AN", label: "Andaman and Nicobar Islands" },
    { value: "AR", label: "Arunachal Pradesh" },
    { value: "AS", label: "Assam" },
    { value: "BR", label: "Bihar" },
    { value: "CH", label: "Chandigarh" },
    { value: "CT", label: "Chhattisgarh" },
    { value: "DN", label: "Dadra and Nagar Haveli" },
    { value: "DD", label: "Daman and Diu" },
    { value: "DL", label: "Delhi" },
    { value: "LD", label: "Lakshadweep" },
    { value: "PY", label: "Puducherry" },
    { value: "GA", label: "Goa" },
    { value: "GJ", label: "Gujarat" },
    { value: "HR", label: "Haryana" },
    { value: "HP", label: "Himachal Pradesh" },
    { value: "JK", label: "Jammu and Kashmir" },
    { value: "JH", label: "Jharkhand" },
    { value: "KA", label: "Karnataka" },
    { value: "KL", label: "Kerala" },
    { value: "MP", label: "Madhya Pradesh" },
    { value: "MH", label: "Maharashtra" },
    { value: "MN", label: "Manipur" },
    { value: "ML", label: "Meghalaya" },
    { value: "MZ", label: "Mizoram" },
    { value: "NL", label: "Nagaland" },
    { value: "OD", label: "Odisha" },
    { value: "PB", label: "Punjab" },
    { value: "RJ", label: "Rajasthan" },
    { value: "SK", label: "Sikkim" },
    { value: "TN", label: "Tamil Nadu" },
    { value: "TS", label: "Telangana" },
    { value: "TR", label: "Tripura" },
    { value: "UP", label: "Uttar Pradesh" },
    { value: "UK", label: "Uttarakhand" },
    { value: "WB", label: "West Bengal" },
  ];

  const handleStateChange = (selectedOption) => {
    setBillingState(selectedOption.value);
  };

  const handleShipStateChange = (selectedOption) => {
    setShippingCountry(selectedOption.value);
  };

  const handleSalutationChange = (event) => {
    setFormData((current) => ({
      ...current,
      someName: event?.value || "",
    }));
  };

  const fetchGst = () => {
    let newValidationMessage = "";
    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;

    if (!gstRegex.test(gstNumber)) {
      newValidationMessage += "Please enter valid Gst Number.\n";
    }
    setValidationMessage(newValidationMessage);

    if (newValidationMessage) {
      window.scrollTo(0, 0); // Scroll to top
      return;
    }
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);
    const apiUrl =
      BASE_URL + `/searchGST?gstin=${gstNumber}&uniqueId=${decryptedUniqueId}`;
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(`GET request failed with status: ${response.status}`);
        }
      })
      .then((responseData) => {
        // setCustomerGstData(responseData); // Update state immediately
        const Data = responseData.data;
        setFormData({
          customerType: "Business",
          status: "Active",
          customerName: Data.lgnm,
          billAddress1: Data.pradr.addr.st,
          billCity: Data.pradr.addr.dst,
          billState: Data.pradr.addr.stcd,
          billZipcode: Data.pradr.addr.pncd,
          billCountry: "India",
          taxable: "Taxable",
          gstTreatment: "Registered Business - Regular",
          gstin: gstNumber,
          uniqueId: decryptedUniqueId,
          placeOfSupply: "[MH] - Maharashtra",
          shipState: "Maharashtra",
          shipCountry: "India",
          billState: "Maharashtra",
          currency: "INR- Indian Rupee",
          openingBalance: "0",
          paymentTerms: "Net 15",
          someName: "",
          firstName: "",
          lastName: "",
          companyName: "",
          email: "",
          contactPerson: [
            {
              other: selectedOther,
              otherFirstname: "",
              otherLastname: "",
              otherEmail: "",
              otherWorkphone: "",
              otherMobile: "",
            },
          ],
        });
        setSelectedOption("Registered Business - Regular");
        const postalCode = responseData.data.pradr.addr.pncd;
        // setPostalCode(postalCode);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <>
      <Container fluid className="zarp-premium-form customer-form-page">
        <Row>
          <Col>
            <div className="my-3">
              <div className="d-flex align-items-center ml-1 mt-4">
                <div
                  className="cursor-pointer d-flex justify-content-center align-items-center"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "50%",
                    height: "35px",
                    width: "38px",
                    cursor: "pointer",
                  }}
                >
                  <ArrowBackIosIcon
                    width={2}
                    onClick={handleCancleClick}
                    className="arrow-child"
                  />
                </div>
                <div className="newcustomer-head ml-2">
                  <h5
                    className="ml-1 mb-0"
                    style={{ letterSpacing: "1px", color: "#086bd5de" }}
                  >
                    Create New Customer
                  </h5>
                </div>
              </div>
            </div>
            <Card className="card-style customer-form-card">
              <div className="my-2">
                {validationMessage && (
                  <Alert severity="error" className="mt-3">
                    {validationMessage.split("\n").map((message, index) => (
                      <div key={index}>{message}</div>
                    ))}
                  </Alert>
                )}{" "}
              </div>
              <Card.Body>
                <Row>
                  <Col md="3" className="">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Customer type*
                      </label>
                      <div className="d-flex my-2">
                        <label className="rdiobox">
                          <input
                            className="mx-1"
                            type="radio"
                            name="customerType"
                            id="cus_bus"
                            value="Business"
                            checked={formData.customerType === "Business"}
                            onChange={handleChange}
                          />
                          <span>Business</span>
                        </label>
                        <label className="rdiobox ml-3">
                          <input
                            className="mx-1"
                            type="radio"
                            name="customerType"
                            id="cus_indivi"
                            value="Individual"
                            checked={formData.customerType === "Individual"}
                            onChange={handleChange}
                          />
                          <span>Individual</span>
                        </label>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="3" className="">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        GST Number
                      </label>
                      <input
                        className="form-control"
                        placeholder="Enter GST Number"
                        id="gstNumber"
                        name="gstNumber"
                        type="text"
                        value={gstNumber}
                        onChange={handleInputChange}
                        style={{
                          borderRadius: "7px",
                          backgroundColor: "#f5f5f5",
                          fontSize: "13px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3" className="">
                    <Form.Group>
                      <label
                        style={{ fontSize: "14px", color: "grey" }}
                      ></label>
                      <button
                        type="button"
                        class="btn p-0 mt-4"
                        onClick={fetchGst}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            backgroundColor: "#F6F6F6",
                            // border:'none',
                            borderRadius: "8px",
                            padding: "4px",
                          }),
                        }}
                      >
                        <span
                          class="text-primary"
                          style={{
                            control: (provided) => ({
                              ...provided,
                              backgroundColor: "#F6F6F6",
                              // border:'none',
                              borderRadius: "8px",
                              padding: "4px",
                              fontSize: "12px",
                              fontWeight: "500",
                            }),
                          }}
                        >
                          Get Customer details
                        </span>
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="3" className="">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Salutation
                      </label>
                      <Select
                        className="mt-0"
                        name="someName"
                        options={unitSalution}
                        value={unitSalution.find(
                          (option) => option.value === formData.someName
                        )}
                        onSelect={handleSalutationChange}
                        placeholder="Select"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            backgroundColor: "#F6F6F6",
                            // border:'none',
                            borderRadius: "8px",
                            padding: "4px",
                          }),
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="3" className="">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        First Name
                      </label>
                      <Form.Control
                        placeholder="Enter First name"
                        name="firstName"
                        id="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        type="text"
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="3" className="">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Last Name
                      </label>
                      <Form.Control
                        className="form-control"
                        placeholder="Enter Last name"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        type="text"
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>

                  {/* <div className="row d-inline-flex pt-3 ml-2"> */}
                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Customer Display Name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Form.Control
                        className="form-control"
                        placeholder="Customer Display Name"
                        list="customerNames"
                        name="customerName"
                        value={formData.customerName}
                        onChange={handleChange}
                        type="text"
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                          borderRadius: "6px",
                        }}
                      />
                      <datalist id="customerNames">
                        {generateNamePairs().map((pair, index) => (
                          <option key={index} value={pair} />
                        ))}
                      </datalist>{" "}
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Customer Email
                      </label>
                      <Form.Control
                        placeholder="Customer Email"
                        name="email"
                        type="text"
                        value={formData.email}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Designation
                      </label>
                      <Form.Control
                        placeholder="Designation"
                        name="designation"
                        type="text"
                        value={formData.designation}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Department
                      </label>
                      <Form.Control
                        placeholder="Department"
                        name="department"
                        type="text"
                        value={formData.department}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Website
                      </label>
                      <Form.Control
                        placeholder="Website"
                        name="website"
                        type="text"
                        value={formData.website}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Customer Phone
                      </label>
                      <Form.Control
                        placeholder="Phone"
                        name="workphone"
                        type="text"
                        value={formData.workphone}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Mobile
                      </label>
                      <Form.Control
                        placeholder="Mobile"
                        name="mobile"
                        type="text"
                        value={formData.mobile}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md="3">
                    <Form.Group>
                      <label style={{ fontSize: "14px", color: "grey" }}>
                        Company Name
                      </label>
                      <Form.Control
                        placeholder="Enter Company Name"
                        name="companyName"
                        type="text"
                        value={formData.companyName}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#F6F6F6",
                          padding: "10px",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="customer-form-tabs mt-2 my-3 mt-4">
                  <div className="">
                    <button
                      className={`btn ml-2 ${new1 ? "btn-link" : "withoutbtn"}`}
                      onClick={() => {
                        showNew1(true);
                        showNew2(false);
                        showNew3(false);
                      }}
                    >
                      Other Details
                    </button>
                    <button
                      className={`btn ml-2 ${new2 ? " btn-link  " : "withoutbtn"
                        }`}
                      onClick={() => {
                        showNew2(true);
                        showNew1(false);
                        showNew3(false);
                      }}
                    >
                      Address
                    </button>
                    <button
                      className={`btn ml-2 ${new3 ? "btn-link " : "withoutbtn"
                        }`}
                      onClick={() => {
                        showNew3(true);
                        showNew1(false);
                        showNew2(false);
                      }}
                    >
                      Contact Person
                    </button>
                    <hr />

                    {new1 && (
                      // the other details line start from the first row
                      <>
                        <Row className="mt-2 customer-detail-row">
                          <Col md="3" className="">
                            <label style={{ fontSize: "14px", color: "grey" }}>
                              GST Treatment
                            </label>
                            <Select
                              className="mt-0"
                              options={GstTreatment}
                              value={GstTreatment.find(
                                (option) =>
                                  option.value === formData.gstTreatment
                              )}
                              onChange={handleGSTtreatment}
                              placeholder="Select a GST Treatment"
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  backgroundColor: "#F6F6F6",
                                  // border:'none',
                                  borderRadius: "8px",
                                  padding: "4px",
                                }),
                              }}
                            />
                          </Col>

                          {selectedOption !== "Overseas" ? (
                            <>
                              <Col md="3">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Place Of Supply
                                </label>
                                <Select
                                  className="mt-0"
                                  options={PlaceOfSupplyOptions}
                                  name="placeOfSupply"
                                  value={PlaceOfSupplyOptions.find(
                                    (option) =>
                                      option.value === formData.placeOfSupply
                                  )}
                                  onChange={handlePlaceOfSupply}
                                  placeholder="Source Of Supply"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "#F6F6F6",
                                      borderRadius: "8px",
                                      padding: "4px",
                                    }),
                                  }}
                                />
                              </Col>
                            </>
                          ) : null}

                          <Col md="3" className="">
                            <label style={{ fontSize: "14px", color: "grey" }}>
                              Currency
                            </label>
                            <Select
                              className="mt-0"
                              options={CurrencyOptions}
                              value={CurrencyOptions.find(
                                (option) => option.value === formData.currency
                              )}
                              onChange={handleCurrency}
                              placeholder="Select Currency ..."
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  backgroundColor: "#F6F6F6",
                                  borderRadius: "8px",
                                  padding: "4px",
                                }),
                              }}
                            />
                          </Col>

                          <Col md="3">
                            <label style={{ fontSize: "14px", color: "grey" }}>
                              Opening Balance
                            </label>
                            <Form.Control
                              placeholder="Opening Balance"
                              name="openingBalance"
                              type="text"
                              value={formData.openingBalance}
                              onChange={handleChange}
                              style={{
                                backgroundColor: "#F6F6F6",
                                padding: "10px",
                              }}
                            />
                          </Col>
                        </Row>

                        {selectedOption === "Registered Business - Regular" ||
                          selectedOption ===
                          "Registered Business - Composition" ||
                          selectedOption === "Special Economic Zone" ||
                          selectedOption === "Deemed Export" ||
                          selectedOption === "Tax Deductor" ||
                          selectedOption === "SEZ Developer" ? (
                          <Row className="mt-3 customer-detail-row">
                            <Col className="" md="3">
                              <label
                                style={{ fontSize: "14px", color: "grey" }}
                              >
                                GSTIN / UIN
                              </label>
                              <Form.Control
                                className=""
                                placeholder="GSTIN / UIN"
                                name="gstin"
                                type="text"
                                onChange={handleGstChange}
                                value={formData.gstin} // Add the value you want to show here
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  padding: "10px",
                                }}
                              />
                            </Col>
                          </Row>
                        ) : null}

                        {selectedOption === "Unregistered Business" ||
                          selectedOption === "Consumer" ? (
                          <Row className="mt-3 customer-detail-row">
                            <Col className="" md="3">
                              <label
                                style={{ fontSize: "14px", color: "grey" }}
                              >
                                PAN
                              </label>
                              <Form.Control
                                className=""
                                placeholder="PAN"
                                name="pan"
                                type="text"
                                value={formData.pan}
                                onChange={handlePanChange}
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  padding: "10px",
                                }}
                              />
                            </Col>
                          </Row>
                        ) : null}

                        <Row className="mt-3 customer-detail-row">
                          <Col md="3">
                            <label style={{ fontSize: "14px", color: "grey" }}>
                              Payment Terms
                            </label>
                            <Select
                              className="mt-0"
                              options={PaymentTermsOptions}
                              value={PaymentTermsOptions.find(
                                (option) =>
                                  option.value === formData.paymentTerms
                              )}
                              onChange={handlePaymentTerms}
                              name="paymentTerms"
                              placeholder="Select Payment Terms"
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  backgroundColor: "#F6F6F6",
                                  // border:'none',
                                  borderRadius: "8px",
                                  padding: "4px",
                                }),
                              }}
                            />
                          </Col>

                          <Col className="" md="3">
                            <label style={{ fontSize: "14px", color: "grey" }}>
                              Facebook
                            </label>
                            <Form.Control
                              placeholder="Facebook Id"
                              name="facebook"
                              type="text"
                              value={formData.facebook}
                              onChange={handleChange}
                              style={{
                                backgroundColor: "#F6F6F6",
                                padding: "10px",
                              }}
                            />
                          </Col>

                          <Col className="" md="3">
                            <label style={{ fontSize: "14px", color: "grey" }}>
                              Twitter
                            </label>
                            <Form.Control
                              placeholder="Twitter Id"
                              name="twitter"
                              type="text"
                              value={formData.twitter}
                              onChange={handleChange}
                              style={{
                                backgroundColor: "#F6F6F6",
                                padding: "10px",
                              }}
                            />
                          </Col>
                        </Row>

                        <Row className="mt-3 customer-detail-row tax-preference-row">
                          <Col md="3">
                            <Form.Group>
                              <label
                                style={{ fontSize: "14px", color: "grey" }}
                              >
                                Tax Preference
                              </label>
                              <div className="d-flex my-2">
                                <label className="rdiobox">
                                  <input
                                    className=""
                                    type="radio"
                                    name="taxPreference" // Give both the same name attribute
                                    id="taxable"
                                    value="Taxable"
                                    checked={formData.taxable === "Taxable"}
                                    onChange={(e) =>
                                      handleTaxable(e, "Taxable")
                                    }
                                  />
                                  <span className="ml-1">Taxable</span>
                                </label>
                                <label className="rdiobox ml-3">
                                  <input
                                    className=""
                                    type="radio"
                                    name="taxPreference" // Give both the same name attribute
                                    id="non-taxable"
                                    value="Non-Taxable"
                                    checked={formData.taxable === "Non-Taxable"}
                                    // onChange={handleChange}
                                    onChange={(e) =>
                                      handleTaxable(e, "Non-Taxable")
                                    }
                                  />
                                  <span className="ml-1">Non-Taxable</span>
                                </label>
                              </div>
                            </Form.Group>
                          </Col>

                          {showTaxable === false && (
                            <Col md="3">
                              <label
                                style={{ fontSize: "14px", color: "grey" }}
                              >
                                Exemption Reason
                              </label>
                              <Form.Control
                                placeholder="Exemption Reason"
                                name="reason"
                                type="text"
                                value={formData.reason}
                                onChange={handleChange}
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  padding: "10px",
                                }}
                              />
                            </Col>
                          )}
                        </Row>
                        {/* third row end */}
                      </>
                    )}

                    {new2 && (
                      <>
                        <div className=" grid-container ">
                          <div className="flex-item">
                            <p className="ml-1 text-center">BILLING ADDRESS</p>
                            <Row className="mt-1">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Attention
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Attention"
                                  name="billAttention"
                                  type="text"
                                  value={formData.billAttention} // Update this line
                                  onChange={handleChange}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>

                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Country
                                </label>
                                <Select
                                  className="mt-0"
                                  options={countryOptions}
                                  value={{
                                    value: billCountry,
                                    label: billCountry,
                                  }}
                                  onChange={handleCountryChange}
                                  placeholder="Select"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "#F6F6F6",
                                      borderRadius: "8px",
                                      padding: "4px",
                                    }),
                                  }}
                                />
                              </Col>
                            </Row>

                            <Row className="mt-2">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Address
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Site1"
                                  name="billAddress1"
                                  type="text"
                                  value={formData.billAddress1}
                                  onChange={handleChange}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>

                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Address
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Site2"
                                  name="billAddress2"
                                  type="text"
                                  value={formData.billAddress2}
                                  onChange={handleChange}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                            </Row>

                            <Row className="mt-2">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  City
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="City"
                                  id="billingCity"
                                  name="billCity"
                                  type="text"
                                  value={formData.billCity}
                                  onChange={handleChange}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  State
                                </label>
                                <Select
                                  id="billingState"
                                  name="billingState"
                                  value={indianStateOptions.find(
                                    (option) => option.value === billState
                                  )} // Find the selected option
                                  onChange={handleStateChange} // Handle state change
                                  options={indianStateOptions} // Pass the state options
                                  placeholder="Select State"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "#F6F6F6",
                                      borderRadius: "8px",
                                      padding: "4px",
                                    }),
                                  }}
                                />
                              </Col>
                            </Row>

                            <Row className="mt-2">
                              <Col className="">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Zipcode
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Zipcode"
                                  id="billingZipcode"
                                  name="billZipcode"
                                  type="text"
                                  value={formData.billZipcode}
                                  onChange={handleChange}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Phone
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Phone"
                                  id="billingPhone"
                                  name="billPhone"
                                  type="text"
                                  value={formData.billPhone}
                                  onChange={handleChange}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                            </Row>

                            <Row className="mt-2">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Fax
                                </label>
                                <Form.Control
                                  className="form-control"
                                  placeholder="Fax"
                                  id="billingFax"
                                  name="billFax"
                                  type="text"
                                  value={formData.billFax}
                                  onChange={handleChange}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                            </Row>
                          </div>

                          <div className="flex-item">
                            <p className=" ml-1 text-center">
                              SHIPPING ADDRESS{" "}
                              <span
                                style={{
                                  fontSize: 12,
                                  color: "blue",
                                  cursor: "pointer",
                                }}
                                onClick={copyData}
                              >
                                <ArrowCircleDown size={16} /> COPY BILLING
                                ADDRESS
                              </span>
                            </p>
                            {/* <div className="vl "></div> */}

                            <Row className="mt-1">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Attention
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Attention"
                                  id="shippingAttention"
                                  name="shippingAttention"
                                  type="text"
                                  value={shipAttention}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setShippingAttention(value);
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value,
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>

                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Country
                                </label>
                                <Select
                                  className="mt-0"
                                  options={countryOptions}
                                  placeholder="Select"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "#F6F6F6",
                                      borderRadius: "8px",
                                      padding: "4px",
                                    }),
                                  }}
                                  name="shippingCountry"
                                  id="shippingCountry"
                                  value={countryOptions.find(
                                    (option) => option.value === shipCountry
                                  )} // Update value prop
                                  onChange={(selectedOption) => {
                                    const { name, value } = selectedOption; // No need for e.target
                                    setShippingCountry(value);
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value,
                                    }));
                                  }}
                                />
                              </Col>
                            </Row>

                            {/* first line end */}

                            <Row className="mt-2">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Address
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Site1"
                                  name="shippingAddress1"
                                  type="text"
                                  value={shipAddress1}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setShippingAddress1(value);
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value,
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>

                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Address
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Site2"
                                  name="shippingAddress2"
                                  type="text"
                                  value={shipAddress2}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setShippingAddress2(value);
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value,
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                            </Row>

                            {/* second line end */}

                            <Row className="mt-2">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  City
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="City"
                                  id="shippingCity"
                                  name="shippingCity"
                                  type="text"
                                  value={shipCity}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setShippingCity(value);
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value,
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  State
                                </label>
                                <Select
                                  placeholder="Select State"
                                  id="shippingCountry"
                                  value={indianStateOptions.find(
                                    (option) => option.value === shipState
                                  )} // Find the selected option
                                  onChange={handleShipStateChange} // Handle state change
                                  options={indianStateOptions} // Use formData to access the selected value
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      backgroundColor: "#F6F6F6",
                                      borderRadius: "8px",
                                      padding: "4px",
                                    }),
                                  }}
                                />
                              </Col>
                            </Row>

                            {/* third line end */}

                            <Row className="mt-2">
                              <Col className="">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Zipcode
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Zipcode"
                                  id="shippingZipcode"
                                  name="shippingZipcode"
                                  type="text"
                                  value={shipZipcode}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setShippingZipcode(value); // Update billingPhone state
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value, // Update billingPhone field in formData
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Phone
                                </label>
                                <Form.Control
                                  className=""
                                  placeholder="Phone"
                                  id="shippingPhone"
                                  name="shippingPhone"
                                  type="text"
                                  value={shipPhone}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setShippingPhone(value);
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value,
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                            </Row>

                            {/* fourth line end */}

                            <Row className="mt-2">
                              <Col className="" md="6">
                                <label
                                  style={{ fontSize: "14px", color: "grey" }}
                                >
                                  Fax
                                </label>
                                <Form.Control
                                  className="form-control"
                                  placeholder="Fax"
                                  id="shippingFax"
                                  name="shippingFax"
                                  type="text"
                                  value={shipFax}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setShippingFax(value);
                                    setFormData((prevFormData) => ({
                                      ...prevFormData,
                                      [name]: value,
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "#F6F6F6",
                                    padding: "10px",
                                  }}
                                />
                              </Col>
                            </Row>

                            {/* fifth line end */}
                          </div>
                        </div>
                      </>
                    )}

                    {new3 && (
                      <div className="contact-person-list">
                        {formData.contactPerson.map((contact, index) => (
                          <div className="contact-person-row" key={`contact-person-${index}`}>
                            <label><span>Salutation</span><Select className="mt-0" options={unitSalution} name={`contactSalutation-${index}`} value={contact.other} onSelect={(option) => handleContactSalutation(option, index)} placeholder="Select" /></label>
                            <label><span>First Name</span><Form.Control placeholder="First Name" name="otherFirstname" value={contact.otherFirstname} onChange={(event) => handleOtherChange(event, index)} /></label>
                            <label><span>Last Name</span><Form.Control placeholder="Last Name" name="otherLastname" value={contact.otherLastname} onChange={(event) => handleOtherChange(event, index)} /></label>
                            <label><span>Email</span><Form.Control placeholder="Email Address" name="otherEmail" value={contact.otherEmail} onChange={(event) => handleOtherChange(event, index)} /></label>
                            <label><span>Work Phone</span><Form.Control placeholder="Work Phone" name="otherWorkphone" value={contact.otherWorkphone} onChange={(event) => handleOtherChange(event, index)} /></label>
                            <label><span>Mobile</span><Form.Control placeholder="Mobile" name="otherMobile" value={contact.otherMobile} onChange={(event) => handleOtherChange(event, index)} /></label>
                            <button type="button" className="contact-person-action delete" aria-label="Delete contact person" onClick={() => handleDelete(index)}><i className="fa fa-trash" /></button>
                            {index === formData.contactPerson.length - 1 && (
                              <button type="button" className="contact-person-action add" aria-label="Add another contact person" title="Add another contact person" onClick={handleAdd}>+</button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="text-right bottom-buttons">
                      <button
                        className="btn-1 btn mt-0"
                        onClick={handleCancleClick}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn-3 btn btn-primary"
                        onClick={handleSaveClick}
                      >
                        {isLoading ? "Saving..." : "Create Customer"}
                      </button>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CustomerNew;
